import { render } from "./InputHighlighted.vue?vue&type=template&id=28c81fe4&scoped=true"
import script from "./InputHighlighted.vue?vue&type=script&lang=js"
export * from "./InputHighlighted.vue?vue&type=script&lang=js"

import "./InputHighlighted.vue?vue&type=style&index=0&id=28c81fe4&scoped=true&lang=scss"

import exportComponent from "/home/itube/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c81fe4"]])

export default __exports__